import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { feLoggingLogEvent, logLevels } from 'actions/log'
import { checkoutSignup } from 'routes/Checkout/checkoutActions'
import { usePricing } from 'routes/Menu/domains/pricing'

export function useSubmitOrder() {
  const dispatch = useDispatch()
  const { pricing } = usePricing()

  return useCallback(() => {
    dispatch(feLoggingLogEvent(logLevels.info, 'useSubmitOrder - in callback'))
    dispatch(checkoutSignup({ pricing }))
  }, [dispatch, pricing])
}
